import { TweenMax } from "gsap";

/* =============================
    * Start Map Animation on Scroll
============================= */
$(window).scroll(function(){
    $(".start-background-container").css("opacity", 1 - $(window).scrollTop() / 250);
});

/* =============================
    * Mouse Parallax
============================= */
$.fn.parallax = function(resistance, mouse) {
    $el = $(this);
    TweenLite.to($el, 0.2, {
        x: -((mouse.clientX - window.innerWidth / 2) / resistance),
        y: -((mouse.clientY - window.innerHeight / 2) / resistance)
    });
};
$(document).mousemove(function(e) {
    $(".cloud-A").parallax(60, e);
    $(".cloud-B").parallax(75, e);
});

/* =============================
    * Animation Pure JS
    * https://blog.bajarangisoft.com/blog/how-can-i-create-slide-animation-on-scroll-using-css
============================= */
var Animation = function ({ offset } = { offset: 10 }) {
    var _elements;

    // Defines the top, bottom and side folds of the screen
    var windowTop = offset * window.innerHeight / 100;
    var windowBottom = window.innerHeight - windowTop;
    var windowLeft = 0;
    var windowRight = window.innerWidth;

    function start(element) {
        // Set the custom attributes
        element.style.animationDelay = element.dataset.animationDelay;
        element.style.animationDuration = element.dataset.animationDuration;
        // Start the animation by setting the animation class
        element.classList.add(element.dataset.animation);
        // Set the element as animated
        element.dataset.animated = "true";
    }

    function isElementOnScreen(element) {
        // Get the boundingbox of the element
        var elementRect = element.getBoundingClientRect();
        var elementTop =
            elementRect.top + parseInt(element.dataset.animationOffset) ||
            elementRect.top;
        var elementBottom =
            elementRect.bottom - parseInt(element.dataset.animationOffset) ||
            elementRect.bottom;
        var elementLeft = elementRect.left;
        var elementRight = elementRect.right;

        // Checks if the element is on the screen
        return (
            elementTop <= windowBottom &&
            elementBottom >= windowTop &&
            elementLeft <= windowRight &&
            elementRight >= windowLeft);

    }

    // Scrolls through the array of elements, checks if the element is on the screen and starts animation
    function checkElementsOnScreen(els = _elements) {
        for (var i = 0, len = els.length; i < len; i++) {
            // Passa para o proximo laço se o elemento ja estiver animado
            if (els[i].dataset.animated) continue;

            isElementOnScreen(els[i]) && start(els[i]);
        }
    }

    // Updates the list of elements to be animated
    function update() {
        _elements = document.querySelectorAll(
            "[data-animation]:not([data-animated])");

        checkElementsOnScreen(_elements);
    }

    // Starts the events
    window.addEventListener("load", update, false);
    window.addEventListener("scroll", () => checkElementsOnScreen(_elements), { passive: true });
    window.addEventListener("resize", () => checkElementsOnScreen(_elements), false);

    // Returns public functions
    return {
        start,
        isElementOnScreen,
        update };

};

// Initializ for animation,js
var options = {
    offset: 20 //percentage of window
};
var animation = new Animation(options);

/* =============================
    * Horizontal Scroll
============================= */
var instance = $(".hs_wrapper");
$.each(instance, function(key, value) {

    // Arrows Scroll
    var arrows = $(instance[key]).find(".arrow"),
        prevArrow = arrows.filter('.arrow-prev'),
        nextArrow = arrows.filter('.arrow-next'),
        box = $(instance[key]).find(".hs"),
        x = 0,
        mx = 0,
        maxScrollWidth = box[0].scrollWidth - (box[0].clientWidth / 2) - (box.width() / 2);

    $(arrows).on('click', function() {

        if ($(this).hasClass("arrow-next")) {
            x = ((box.width() / 2)) + box.scrollLeft();
            box.animate({
                scrollLeft: x,
            })
        } else {
            x = ((box.width() / 2)) - box.scrollLeft();
            box.animate({
                scrollLeft: -x,
            })
        }

    });

    // Mouse Drag
    $(box).on({
        mousemove: function(e) {
            var mx2 = e.pageX - this.offsetLeft;
            if (mx) this.scrollLeft = this.sx + mx - mx2;
        },
        mousedown: function(e) {
            this.sx = this.scrollLeft;
            mx = e.pageX - this.offsetLeft;
        },
        scroll: function() {
            toggleArrows();
        }
    });

    $(document).on("mouseup", function() {
        mx = 0;
    });

    // Toggle Arrows Activation
    function toggleArrows() {
        if (box.scrollLeft() > maxScrollWidth - 10) {
            // disable next button when right end has reached
            nextArrow.addClass('disabled');
        } else if (box.scrollLeft() < 10) {
            // disable prev button when left end has reached
            prevArrow.addClass('disabled')
        } else {
            // both are enabled
            nextArrow.removeClass('disabled');
            prevArrow.removeClass('disabled');
        }
    }

});
